// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3cqv2","rootSmall":"AddTileButton_rootSmall__17LSw"};